import { render, staticRenderFns } from "./sku-search-template.vue?vue&type=template&id=4c36ff46"
import script from "./sku-search-template.vue?vue&type=script&lang=js"
export * from "./sku-search-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports